import React from "react";
import styled from "styled-components";

const VolumeStepper = ({ value, onChange, min = 0, max = 100, step = 25 }) => {
  const steps = [];
  for (let i = min; i <= max; i += step) {
    steps.push(i);
  }

  return (
    <StepperRow>
      <StepperContainer>
        <VisualTrack>
          {steps.map((stepValue, index) => (
            <React.Fragment key={stepValue}>
              <StepDot current={value === stepValue} />
              {index < steps.length - 1 && <StepLine />}
            </React.Fragment>
          ))}
        </VisualTrack>

        <NativeInput
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onChange}
        />

      </StepperContainer>
      <Percentage>{value}</Percentage>
    </StepperRow>
  );
};

export default VolumeStepper;

const StepperRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 32px;
`;

const StepperContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
`;

const NativeInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0; 
  cursor: pointer;
  z-index: 2;
`;

const VisualTrack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 1;
  pointer-events: none;
`;

const StepDot = styled.div`
  width: ${({ current }) => current ? '20px' : '14px'};
  height: ${({ current }) => current ? '20px' : '14px'};
  border-radius: 50%;
  background: ${({ current, theme }) => 
    current ? theme.menu.background : 'rgba(45, 49, 72, 1)'};
  border: ${({ current, theme }) => current ? `1px solid ${theme.primaryButton.borderColor}` : 'none'};
  box-shadow: ${({ current, theme }) => current ? `0 0 0 3px ${theme.primaryButton.borderColor}` : 'none'};
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
  z-index:2;
`;

const StepLine = styled.div`
  flex: 1;
  height: 4px;
  background: rgba(45, 49, 72, 1);
  transition: background 0.2s ease;
  margin: 0 -2px;
  z-index:1;
`;

const Percentage = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  min-width: 35px;
  text-align: left;
`;